const listingChoices = ['NONE', 'FULL', 'NUMERIC_ORDER']

export default listingChoices
